import styled from 'styled-components';

const GlobalFooterWrapper = styled.div`
  font-family: -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Helvetica Neue",sans-serif;
  font-size: .94rem;
`;

export default GlobalFooterWrapper;
